import { useCallback } from 'react';

import { useMutation } from '@apollo/client';
import * as Sentry from '@sentry/react';

import type { FormName } from '@coursera/event-pulse-types';

import SetOnboardingSeen from 'bundles/onboarding-common/queries/SetOnboardingSeen.graphql';
import type {
  SetOnboardingSeenMutation,
  SetOnboardingSeenMutationVariables,
} from 'bundles/onboarding-common/queries/__generated__/SetOnboardingSeen';

const useSetOnboardingSeen = (onboardingVersion: FormName) => {
  const [mutation] = useMutation<SetOnboardingSeenMutation, SetOnboardingSeenMutationVariables>(SetOnboardingSeen, {
    context: { clientName: 'gatewayGql' },
  });

  const setOnboardingSeen = useCallback<(handleErrorTracking?: () => void) => Promise<void>>(
    async (handleErrorTracking) => {
      try {
        await mutation({
          variables: {
            onboardingVersion,
          },
        });
      } catch (error) {
        Sentry.captureMessage('[Onboarding-2022]: Unable to set onboarding seen', { extra: { error } });
        handleErrorTracking?.();
      }
    },
    [mutation, onboardingVersion]
  );

  return {
    setOnboardingSeen,
  };
};

export default useSetOnboardingSeen;
